/**
 * Documents not found behavior for ERP Accelerator.
 */

// app/not-found.tsx
'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { Button } from '@/components/ui/button';

/**
 * Handles not found behavior.
 */
export default function NotFound() {
  const router = useRouter();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 text-center animate-page-enter">
      <p className="text-[96px] font-bold leading-none tracking-tight text-muted-foreground/40">404</p>
      <h1 className="mt-4 text-xl font-semibold text-brand-ink">Page not found</h1>
      <p className="mt-2 mb-6 text-sm text-muted-foreground">
        Sorry, the page you&rsquo;re looking for doesn&rsquo;t exist.
      </p>
      <Button onClick={() => router.push('/')}>Go Back Home</Button>
    </div>
  );
}
